module.exports = __webpack_public_path__ + "static/googleplay-8f33c2b1f063596a24e6153c65aba2ed.svg";